


import Vue from 'vue';
import IntroComponent from '@/components/home/intro/intro.vue';
import AboutComponent from '@/components/home/about/about.vue';
import ContactComponent from '@/components/home/contact/contact.vue';
import {pageTitle} from "@/components/common/pageTitle";
import $ from "jquery";
import {RouteName} from "@/router";

const scrollTo = (position) => {
    $('html, body').animate({
        scrollTop: position
    }, 700);
};

export default Vue.extend({
    props: {
        contact: Boolean
    },
    created(): void {
        pageTitle.setBaseTitle();
    },
    mounted(): void {
        if (this.$route.name === RouteName.contact) {
            // @ts-ignore
            setTimeout(() => this.scrollToContact(), 200);
        }
    },
    watch: {
        contact(newValue) {
            if (newValue) {
                // @ts-ignore
                this.scrollToContact();
            } else {
                scrollTo(0);
            }
        }
    },
    methods: {
        scrollToContact() {
            scrollTo(($('#kontakt') as any).offset().top - 75);
        }
    },
    metaInfo() {
        return {
            link: [
                {vmid: 'canonical', rel: 'canonical', href: location.origin + this.$route.fullPath}
            ]
        }
    },
    components: {
        'intro': IntroComponent,
        'about': AboutComponent,
        'contact': ContactComponent
    }
});
